var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"d-sm-down-none"}),_vm._v(" "),_c('span',{staticClass:"float-right"},[_vm._m(0),_vm._v(" | "+_vm._s(_vm.$lang.Login.LabelVersion)+" "+_vm._s(_vm.version)+"\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"javascript:void(0);"}},[_c('strong',[_vm._v("ZSistema")])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97b6bffe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/layout/Footer.vue
// module id = null
// module chunks = 